import React from 'react';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../../../store/hooks';
import { Form } from 'react-bootstrap';
import CustomAlert from '../../../../../../components/Shared/Alert/CustomAlert';
import Loading from '../../../../../../components/Shared/Loader/Loading';
import { LotItemSchema } from '../../../../../ValidationForm/validationSchema';
import { addLotDetails } from '../../../../../../store/INV/MasterItems/LotItemSlice';
import ToastSwal from '@components/Shared/Alert/ToastSwal';

interface Props {
  lineData: any;
  setAddedLots: React.Dispatch<React.SetStateAction<any>>;
  onClose: () => void;
}

const AddLotItem: React.FC<Props> = ({ lineData, onClose, setAddedLots }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  console.log(lineData);

  const formik = useFormik({
    initialValues: {
      itemId: lineData.transactionItemId,
      lotNumber: '',
      expirationDate: ''
    },

    validationSchema: LotItemSchema(t),

    onSubmit: values => {
      dispatch(
        addLotDetails({
          itemId: lineData.transactionItemId,
          lotNumber: values.lotNumber,
          expirationDate: values.expirationDate
        })
      )
        .unwrap()
        .then(res => {
          // debugger;
          if (res.succeeded === true) {
            setAddedLots((prev: any) => ({
              ...prev,
              [lineData.transactionItemId]: res.data
            }));
            // debugger;
            formik.resetForm();
            // CustomAlert({ action: 'Add' });
            ToastSwal({
              icon: 'success',
              position: 'bottom-start',
              title: 'تم إضافة رقم التشغيل'
            });
            onClose();
          } else {
            setAddedLots((prev: any) => ({
              ...prev,
              1: null // تحديث العنصر الخاص بالـ index المحدد
            }));
            CustomAlert({ action: 'Error' });
          }
        })
        .catch(error => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  return (
    <>
      <Loading loading={false} Type='Dots'>
        <Form onSubmit={formik.handleSubmit}>
          <div className='row  '>
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('رقم التشغيل')}</label>
                <Form.Control
                  autoComplete='off'
                  className='form-control'
                  type='text'
                  name='lotNumber'
                  onChange={formik.handleChange}
                  value={formik.values.lotNumber}
                  isInvalid={!!(formik.touched.lotNumber && formik.errors.lotNumber)}
                />
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.lotNumber}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('تاريخ الإنتهاء')}</label>
                <Form.Control
                  className='form-control'
                  type='date'
                  name='expirationDate'
                  onChange={formik.handleChange}
                  value={formik.values.expirationDate || ''}
                  isInvalid={!!(formik.touched.expirationDate && formik.errors.expirationDate)}
                />
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.expirationDate}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-6  '>
              <div className=' form-group   d-flex justify-content-end '>
                <button
                  disabled={formik.isSubmitting}
                  type='submit'
                  className='btn me-1 btn-theme form-control w-100 '
                >
                  {formik.isSubmitting ? (
                    <div className='spinner-border spinner-border-sm me-2'></div>
                  ) : (
                    <i className='fa fa-save fa-fw me-1'></i>
                  )}
                  {t('Save')}
                </button>
              </div>
            </div>
            <div className='col-xl-6'>
              <button type='button' className=' btn btn-default w-100' onClick={onClose}>
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </div>
        </Form>
      </Loading>
    </>
  );
};

export default AddLotItem;
